import React from 'react';
import './Injectmoldflexible.css';
import chooplast from '../../../imgs/Injectmoldflex.webp';
 
const Injectmoldflexible = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>

                <div className="Ordinary-content">
                    <h2 className="">Injection Molding Machine</h2>
                    <p>Advantages:</p>
                    <ul className="Ordinary-text">
                        <li>Flexible cap style design by purchasing various molds</li>
                        <li>Not only can produce ordinary caps, but also some special functional caps:
                            such as flip-top caps, two-color caps, etc.</li>
                        <li>Not limited to the production of bottle caps, but also other plastic products such as bottle handles</li>
                        <li>High-dimensional precision</li>
                    </ul>
                    <p>Disadvantages:</p>
                    <ul className="Ordinary-text">
                        <li>The production efficiency is lower than that of the compression molding machine</li>
                        <li>The cost of replacing and maintaining the mold is high.</li>

                    </ul>
                    <div className="Ordinary">
                        <img src={chooplast} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                    </div>
                    <p className="Ordinary-text">How to choose plastic bottle caps production equipment?
                        Should you choose injection molding machines or compression molding machines?
                        In general, injection molding machine has advantages over compression molding machines
                        if you are not just producing regular plastic bottle caps.</p>
                </div>

            </div>

        </div>
    );
};

export default Injectmoldflexible;
